export const getPropertySpecifications = (state) => state.propertySpecifications